import type { SearchViewType } from '@/components/Search/types';

export const getProductTypeByActiveTab = (activeTab?: SearchViewType) => {
  switch (activeTab) {
    case 'watches':
      return 'Watch';
    case 'straps':
      return 'Strap';
    case 'eyewear':
      return 'Eyewear';
  }
  return null;
};
